module.exports = __webpack_public_path__ + "static/img/rongyu3.dc9dc93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rongyu3.png
// module id = G0wO
// module chunks = 1